import { render, staticRenderFns } from "./TipDeleteDialog.vue?vue&type=template&id=2085a961&"
import script from "./TipDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./TipDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports